module.exports = __webpack_public_path__ + "img/jobmule_referenti.dfd43e77.png";